import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { difference } from 'lodash';
import BtnAdd from '../../../../Components/Utility/FilterAction/BtnAdd';
import BtnDelete from '../../../../Components/Utility/FilterAction/BtnDelete';
import BtnSelectAll from '../../../../Components/Utility/FilterAction/BtnSelectAll';
import SearchBar from '../../../../Components/Utility/FilterAction/SearchBar';
import Loader from '../../../../Components/Utility/Loader/Loader';
import BomLibraryGroupCard from '../../../../Components/Card/BomLibraryGroupCard/BomLibraryGroupCard';
import { fetchBomTypeByIdAction } from '../../BomType/Store/BomType.action';
import { clearLibraryList, deleteBomLibraryGroupByIdAction, fetchBomLibraryGroupList } from '../store/BomLibrary.action';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';
import { shortenString, Page_Size } from '../../../../Components/helper';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';

function BomLibraryGroup({ match, fetchBomTypeByIdAction, BOMProperty, fetchBomLibraryGroupList, deleteBomLibraryGroupByIdAction }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const paramId = match.params.id;
  const {
    Users: { logInRights },
  } = useSelector((redState) => redState);

  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [isSelectAll, setSelectAll] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [selectedBomLibraryGroupId, setBomId] = useState(null);
  const [state, setState] = useState({
    bomLibraryGroupList: [],
    pageIndex: 1,
    pageSize: Page_Size,
    hasMore: true,
    loading: true,
    totalRecords: null,
    searchText: '',
    searchLoaded: false,
  });

  const { CheckActionPermission } = useComponent();
  const BomLibraryAddEditAccess = CheckActionPermission(logInRights, 'libraries', 'bom', 'addEdit');
  const BomLibraryDeleteAccess = CheckActionPermission(logInRights, 'libraries', 'bom', 'delete');
  const [showFilterMobile, setFilterMobile] = useState(false);
  const [showSearchMobile, setSearchMobile] = useState(false);
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(systemMasterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  useEffect(() => {
    async function fetchAPI() {
      if (paramId == null || paramId === '') {
        return;
      }
      const res = await fetchBomTypeByIdAction(paramId);
      if (!res) {
        history.push('/libraries/bom-type');
      }
      const params = {
        bomTypeId: paramId,
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        bomLibraryGroupList: state.bomLibraryGroupList,
        totalRecords: state.totalRecords,
        searchText: state.searchText,
      };
      await getBomLibraryGroupList(params);
    }
    fetchAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramId]);

  const getBomLibraryGroupList = async (data) => {
    if (data.totalRecords !== null && data.bomLibraryGroupList.length >= data.totalRecords) {
      setState((state) => ({
        ...state,
        hasMore: false,
      }));
      return;
    }

    setState((state) => ({
      ...state,
      loading: true,
    }));
    const params = {
      pageIndex: data.pageIndex,
      pageSize: data.pageSize,
      bomTypeId: data.bomTypeId,
    };
    if (data.searchText) {
      params.searchText = data.searchText;
    }

    const res = await fetchBomLibraryGroupList(params);
    if (res?.doc) {
      setState((state) => ({
        ...state,
        bomLibraryGroupList: [...data.bomLibraryGroupList, ...res.doc],
        pageIndex: data.pageIndex + 1,
        loading: false,
        totalRecords: res?.totalCount || 0,
      }));
      if (data.isSelectAll) {
        const selectedItems = [...data.selectedIdArray];
        const newGroupIds = res.doc.map((item) => item._id);
        setSelectedIdArray([...selectedItems, ...newGroupIds]);
      }
    }
  };

  const refreshPage = async () => {
    setState((state) => ({
      ...state,
      loading: true,
      pageIndex: 1,
      bomLibraryGroupList: [],
      totalRecords: null,
      hasMore: true,
      searchText: '',
      searchLoaded: false,
    }));
    setSelectedIdArray([]);
    setBomId(null);
    setSelectAll(false);
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize,
      bomLibraryGroupList: [],
      totalRecords: null,
      isSelectAll: false,
      selectedIdArray: [],
      bomTypeId: paramId,
    };
    await getBomLibraryGroupList(params);
  };

  const onSelectCheckBox = async (e, id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (findItems.length > 0) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    } else {
      setSelectedIdArray([...selectedItems, id]);
    }
  };

  const deleteBomLibraryGroup = (id) => {
    setBomId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const deleteById = async () => {
    setState((state) => ({
      ...state,
      loading: true,
    }));
    const params = {};
    if (selectedBomLibraryGroupId) {
      params.bomGroupId = [selectedBomLibraryGroupId];
    } else {
      params.bomGroupId = [...selectedIdArray];
    }

    const res = await deleteBomLibraryGroupByIdAction(params, t);
    if (res) {
      setShowConfirmationPopup(!showConfirmationPopup);
      refreshPage();
    } else {
      setState((state) => ({
        ...state,
        loading: false,
      }));
    }
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
    } else {
      const selectedItems = [...selectedIdArray];
      for (const item of state.bomLibraryGroupList) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (findItems.length === 0) {
          selectedItems.push(item._id);
        }
      }
      setSelectedIdArray(selectedItems);
    }
    setSelectAll(!isSelectAll);
  };

  useEffect(() => {
    if (state.bomLibraryGroupList.length > 0) {
      const stateIds = state.bomLibraryGroupList.map((item) => item._id);
      const selectedItems = [...selectedIdArray];
      const unSelectedItems = difference(stateIds, selectedItems);
      if (unSelectedItems.length > 0) {
        setSelectAll(false);
      } else {
        setSelectAll(true);
      }
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIdArray]);

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    console.log(targetValue);
    setState((state) => ({
      ...state,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        setState((state) => ({
          ...state,
          loading: true,
          pageIndex: 1,
          bomLibraryGroupList: [],
          totalRecords: null,
          hasMore: true,
        }));
        setSelectedIdArray([]);
        setBomId(null);
        setSelectAll(false);
        const params = {
          pageIndex: 1,
          pageSize: state.pageSize,
          searchText: state.searchText,
          bomLibraryGroupList: [],
          totalRecords: null,
          isSelectAll: false,
          selectedIdArray: [],
          bomTypeId: paramId,
        };
        await getBomLibraryGroupList(params);
        setState((state) => ({
          ...state,
          loading: false,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.searchText]);

  const handleNextPagesInScroll = async () => {
    const params = {
      pageIndex: state.pageIndex,
      pageSize: state.pageSize,
      searchText: state.searchText,
      bomLibraryGroupList: state.bomLibraryGroupList,
      totalRecords: state.totalRecords,
      isSelectAll,
      selectedIdArray,
      bomTypeId: paramId,
    };
    await getBomLibraryGroupList(params);
  };

  const handleMobileSearch = (clear) => {
    if (clear) {
      setState((state) => ({
        ...state,
        searchText: '',
        searchLoaded: true,
      }));
    }
    setSearchMobile(!showSearchMobile);
  };

  const getName = (name) => {
    let nameSpilt = name?.split(' ');
    nameSpilt = nameSpilt?.map((na) => na.charAt(0).toUpperCase() + na.slice(1));
    return nameSpilt?.join(' ') || '--';
  };

  const clearBomData = async () => {
    await dispatch(clearLibraryList());
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">
            {BOMProperty?.name} {t('BOM_LIBRARY.BOM_LIBRARY_GROUP.BOM_LIBRARY_GROUPS.LIBRARY_GROUPS')}
          </h4>
        </div>
        <div className="search-filter">
          <SearchBar
            onSearch={handleSearch}
            value={state.searchText}
            placeholder={`${t('BOM_LIBRARY.BOM_LIBRARY_GROUP.BOM_LIBRARY_GROUPS.SEARCH')} ${getName(BOMProperty?.name)} ${t(
              'BOM_LIBRARY.BOM_LIBRARY_GROUP.BOM_LIBRARY_GROUPS.GROUPS',
            )}`}
            showMobileSearch={showSearchMobile}
            handleMobileSearch={handleMobileSearch}
          />
          <div className="web-filter">
            {BomLibraryAddEditAccess && (
              <Link className="cursor-pointer text-dark text-decoration-none" to={`/libraries/bom-library-group/add/${match.params.id}`}>
                <BtnAdd addEditAccess={BomLibraryAddEditAccess} />
              </Link>
            )}
            {BomLibraryDeleteAccess && (
              <BtnDelete
                multiDelete={() => {
                  deleteBomLibraryGroup(null);
                }}
                isDisabled={selectedIdArray?.length <= 0}
              />
            )}
            {(BomLibraryAddEditAccess || BomLibraryDeleteAccess) && (
              <BtnSelectAll handleSelectAll={handleSelectAll} isSelectAll={isSelectAll} isDisabled={state?.bomLibraryGroupList.length <= 0} />
            )}
          </div>
          <button type="button" onClick={() => setFilterMobile(!showFilterMobile)} className="filter-btn btn-mobile-more">
            <i className="icon-new-more" />
          </button>
        </div>
        <div className={showFilterMobile ? 'mobile-filter open' : 'mobile-filter'}>
          {BomLibraryAddEditAccess && (
            <Link className="cursor-pointer text-dark text-decoration-none" to={`/libraries/bom-library-group/add/${match.params.id}`}>
              <BtnAdd addEditAccess={BomLibraryAddEditAccess} />
            </Link>
          )}
          {BomLibraryDeleteAccess && (
            <BtnDelete
              multiDelete={() => {
                deleteBomLibraryGroup(null);
              }}
              isDisabled={selectedIdArray?.length <= 0}
            />
          )}
          {(BomLibraryAddEditAccess || BomLibraryDeleteAccess) && (
            <BtnSelectAll handleSelectAll={handleSelectAll} isSelectAll={isSelectAll} isDisabled={state.bomLibraryGroupList.length <= 0} />
          )}
        </div>
      </div>

      <div className="container-fluid">
        <div className="d-flex justify-content-end my-3">
          <Link className="cursor-pointer text-dark text-decoration-none" to={`/libraries/bom-library/${paramId}`}>
            <Button className="btn btn-page-filter" onClick={clearBomData}>
              <span className="lib-name" title={BOMProperty?.name}>
                {shortenString(BOMProperty?.name, 20)} {t('BOM_LIBRARY.BOM_LIBRARY_GROUP.BOM_LIBRARY_GROUPS.LIBRARY')}
              </span>
            </Button>
          </Link>

          <Button className="btn-active btn btn-page-filter">
            <span className="lib-name" title={BOMProperty?.name}>
              {shortenString(BOMProperty?.name, 20)} {t('BOM_LIBRARY.BOM_LIBRARY_GROUP.BOM_LIBRARY_GROUPS.LIBRARY_GROUPS')}
            </span>
          </Button>
        </div>

        <div className="">
          {!state.loading && state.bomLibraryGroupList.length === 0 && (
            <div className="w-100 text-center">
              <h6>{t('BOM_LIBRARY.BOM_LIBRARY_GROUP.BOM_LIBRARY_GROUPS.NO_RECORDS_FOUND')}</h6>
            </div>
          )}
        </div>
      </div>

      {(state.bomLibraryGroupList !== null || state.bomLibraryGroupList.length !== 0) && (
        <InfiniteScroll
          dataLength={state.bomLibraryGroupList.length} // This is important field to render the next data
          next={() => handleNextPagesInScroll()}
          hasMore={state.hasMore}
          loader={state.loading && <Loader />}
        >
          <div className="container-fluid">
            <div className="row">
              {state?.bomLibraryGroupList?.map((item, i) => (
                <BomLibraryGroupCard
                  key={i}
                  paramId={paramId}
                  item={item}
                  index={i}
                  onDelete={deleteBomLibraryGroup}
                  onCheck={onSelectCheckBox}
                  selectedIds={selectedIdArray}
                  catBasedOnPTData={catBasedOnPTData}
                />
              ))}
            </div>
          </div>
        </InfiniteScroll>
      )}

      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          message={t('BOM_LIBRARY.BOM_LIBRARY_GROUP.BOM_LIBRARY_GROUPS.DELETE_LIBRARY_GROUP')}
          title={t('BOM_LIBRARY.BOM_LIBRARY_GROUP.BOM_LIBRARY_GROUPS.DELETE')}
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
        />
      )}
    </>
  );
}

const mapStateToProps = ({ BomLibraryDetails }) => {
  const { BOMProperty } = BomLibraryDetails;
  return {
    BOMProperty,
  };
};

const mapStateToDispatch = {
  fetchBomTypeByIdAction,
  fetchBomLibraryGroupList,
  deleteBomLibraryGroupByIdAction,
};

export default connect(mapStateToProps, mapStateToDispatch)(BomLibraryGroup);
